export const akunSubChildCategoryFormData = (dropdownAkunSubCategory) => {
    return [
        {
            id : "sub_child_kategori_akun",
            label : "Sub Child Akun Kategori",
            fields : [{
                type: "input",
                placeholder: "Masukan Nama Sub Child Kategori Akun"
            }]
        },
        {
            id : "id_akun_sub_kategori",
            label : "Pilih Akun Sub Kategori",
            fields : [{
                type : "option",
                options: dropdownAkunSubCategory
            }]
        }
    ]
}